import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { Select } from "@dash/select";
import type { FC } from "react";

import { ContactOption } from "./customerSupportTicketsContactOptions";

type MailboxesQuery = {
  isLoading: boolean;
};

type Props = {
  onClose: () => void;
  subject: string;
  onSubjectChange: (value: string) => void;
  message: string;
  onMessageChange: (value: string) => void;
  sourceMailbox: string;
  onSourceMailboxChange: (value: string) => void;
  mailboxOptions: Array<{ label: string; value: string }>;
  mailboxesQuery: MailboxesQuery;
  selectedContact: string;
  onContactSelectChange: (value: string | undefined) => void;
  contactOptions: ContactOption[];
  onSubmit: () => void;
  isBusy: boolean;
};

export const CustomerSupportCreateTicketDialog: FC<Props> = ({
  onClose,
  subject,
  onSubjectChange,
  message,
  onMessageChange,
  sourceMailbox,
  onSourceMailboxChange,
  mailboxOptions,
  mailboxesQuery,
  selectedContact,
  onContactSelectChange,
  contactOptions,
  onSubmit,
  isBusy,
}) => (
  <Dialog onClose={onClose} header="Nowe zgłoszenie" placement="center" css={{ width: "420px" }}>
    <div css={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <TextField
        label="Temat"
        value={subject}
        onChange={onSubjectChange}
        css={{ width: "100%", input: { height: "46px" }, padding: 0 }}
        autoFocus
      />
      <Select
        label="Skrzynka odpowiedzi"
        value={sourceMailbox}
        onChange={(value) => onSourceMailboxChange(value ?? "")}
        options={mailboxOptions}
        isDisabled={mailboxesQuery.isLoading}
        allowEmptySelection
        placeholder="Bez skrzynki (tylko w aplikacji)"
      />
      <Select
        label="Kontakt"
        value={selectedContact}
        onChange={(value) => onContactSelectChange(value)}
        options={contactOptions.map((option) => ({ label: option.label, value: option.value }))}
        isDisabled={contactOptions.length === 0}
      />
      <TextField
        label="Wiadomość"
        value={message}
        onChange={onMessageChange}
        multiline
        css={{ width: "100%", textarea: { minHeight: "110px", resize: "vertical" }, padding: 0 }}
      />
    </div>
    <div css={{ display: "flex", justifyContent: "flex-end", marginTop: "1rem" }}>
      <Button css={{ width: "auto", padding: "0.5rem 1rem" }} onClick={onSubmit} isLoading={!!isBusy}>
        Utwórz
      </Button>
    </div>
  </Dialog>
);
